import React from 'react';
import { useTranslate } from 'react-redux-multilingual'

/**
 * Bandeau 404 affiché sur les pages publiques de consultation (ticket, commande, devis)
 * lorsque le document n'existe pas, que le token est invalide, ou en cas de 403.
 */
const PublicDocumentNotFound = () => {
    const t = useTranslate();
    return(
        <div className="not-found-wrap text-center">
            <h1 className="text-60">404</h1>
            <p className="text-36 subheading mb-3">Error!</p>
            <p className="mb-5 text-muted text-18">
                {t('error404Msg')}
            </p>
        </div>
    )
}

export default PublicDocumentNotFound;
